import { Injectable } from "@angular/core";
import { User } from '../Models/USermodel';

@Injectable({ providedIn: "root" })
export class StorageService {
    private _user: User = null;
    constructor() {
        this._user = JSON.parse(sessionStorage.getItem("user"));
    }
    setUser(user) {
        debugger;
        sessionStorage.setItem("user", user);
        this._user = user;
    }
    get() {
        return this._user;
    }

    clear () {      
        sessionStorage.clear();
    }
}